import { formatTime } from '@24i/nxg-core-utils';
import { formTimeString } from '@24i/player-utils';
const HOUR_MS = 60 * 60 * 1000;
export const formatVodTimeText = (milliseconds, showHours) => {
    const finalShowHours = showHours === true || (showHours === 'auto' && milliseconds > HOUR_MS);
    return formTimeString(milliseconds, finalShowHours, false);
};
export const formatTimeText = (milliseconds, options) => {
    if (!(options === null || options === void 0 ? void 0 : options.loadedMetadata))
        return '';
    if (options === null || options === void 0 ? void 0 : options.isLive) {
        if (options === null || options === void 0 ? void 0 : options.showLiveLabel)
            return (options === null || options === void 0 ? void 0 : options.liveLabel) || 'LIVE';
        return formatTime(milliseconds, options === null || options === void 0 ? void 0 : options.timeFormat);
    }
    const finalShowHours = (options === null || options === void 0 ? void 0 : options.showHours) === true || ((options === null || options === void 0 ? void 0 : options.showHours) === 'auto' && milliseconds > HOUR_MS);
    return formTimeString(milliseconds, finalShowHours, false);
};
//# sourceMappingURL=timeTexts.js.map